import { useEffect, useState } from 'react';

/** Две колонки формы публикации (lg, 1024px): превью справа. Уже — превью встраиваем в поток формы. */
const QUERY = '(min-width: 1024px)';

export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY).matches : true,
  );
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const on = () => setDesktop(mql.matches);
    mql.addEventListener('change', on);
    on();
    return () => mql.removeEventListener('change', on);
  }, []);
  return desktop;
}
